<h1 class="pb-5">{{ 'CATEGORIES.title' | translate: { count: 0 } }}</h1>

<div class="bp-button-tab mb-5">
  <a mat-button class="bp-button" [routerLink]="['settings' | localize]" routerLinkActive="active-link">{{ 'COMMON.settings' | translate }}</a>
  <button mat-button class="bp-button" [routerLink]="['products' | localize]" routerLinkActive="active-link" [disabled]="disableSections">{{ 'PRODUCTS.title' | translate: { count: 0 }  }}</button>
</div>

<router-outlet></router-outlet>
